import { useMemo } from 'react'
import { COLORS } from 'styles/colors'

const roundToTenth = (value: number) => Math.round(value * 10) / 10

interface MilkYieldChartInfoProps {
	total_sell_milk_sum: number | null | undefined
	total_reject_milk_sum: number | null | undefined
}

export const useGetMilkYieldChartInfo = ({
	total_sell_milk_sum,
	total_reject_milk_sum,
}: MilkYieldChartInfoProps) => {
	const sell = roundToTenth(total_sell_milk_sum ?? 0)
	const reject = roundToTenth(total_reject_milk_sum ?? 0)

	const dotsInfo = useMemo(() => {
		return [
			{
				segmentValue: sell,
				color: COLORS.blue,
			},
			{
				segmentValue: reject,
				color: COLORS.error,
			},
		]
	}, [sell, reject])

	const today_total = useMemo(() => {
		return roundToTenth(sell + reject)
	}, [sell, reject])

	return {
		dotsInfo,
		today_total,
		total_sell_milk_sum: sell,
		total_reject_milk_sum: reject,
	}
}
